import { render, staticRenderFns } from "./examination-add-or-update.vue?vue&type=template&id=aa0f6560&scoped=true"
import script from "./examination-add-or-update.vue?vue&type=script&lang=js"
export * from "./examination-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./examination-add-or-update.vue?vue&type=style&index=0&id=aa0f6560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0f6560",
  null
  
)

export default component.exports